(function () {
  const SECTION_SELECTOR = '[data-behold-instagram]';

  function getImageUrl(post) {
    const sizes = post.sizes;
    if (sizes) {
      return sizes.medium?.mediaUrl || sizes.large?.mediaUrl || sizes.small?.mediaUrl || post.mediaUrl;
    }
    return post.mediaUrl;
  }

  function getAltText(post) {
    const caption = post.prunedCaption || post.caption;
    return caption && caption.trim() !== '' ? caption : 'Instagram post';
  }

  function appendMediaOverlay(link, iconUrl) {
    const badge = document.createElement('span');
    badge.className = 'instagram-feed__overlay';
    badge.setAttribute('aria-hidden', 'true');
    const icon = document.createElement('img');
    icon.src = iconUrl;
    icon.alt = '';
    icon.width = 24;
    icon.height = 24;
    badge.appendChild(icon);
    link.appendChild(badge);
  }

  async function initBeholdInstagram(root) {
    if (root.dataset.beholdInitialized === 'true') return;
    root.dataset.beholdInitialized = 'true';

    const feedUrl = root.dataset.feedUrl;
    const limit = parseInt(root.dataset.postLimit, 10) || 6;
    const grid = root.querySelector('[data-behold-instagram-grid]');
    const loading = root.querySelector('[data-behold-instagram-loading]');
    const error = root.querySelector('[data-behold-instagram-error]');

    if (!feedUrl || !grid) {
      if (loading) loading.hidden = true;
      return;
    }

    const galleryIconUrl = root.dataset.galleryIcon;
    const videoIconUrl = root.dataset.videoIcon;

    try {
      const response = await fetch(feedUrl);
      if (!response.ok) throw new Error('Feed request failed');

      const data = await response.json();
      const posts = (data.posts || []).slice(0, limit);

      if (posts.length === 0) {
        root.hidden = true;
        return;
      }

      const fragment = document.createDocumentFragment();

      posts.forEach((post) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = post.permalink;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.className = 'instagram-feed__link';
        link.setAttribute('aria-label', getAltText(post));

        const img = document.createElement('img');
        img.src = getImageUrl(post);
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';

        const medium = post.sizes?.medium;
        if (medium) {
          img.width = medium.width;
          img.height = medium.height;
        }

        link.appendChild(img);

        if (post.mediaType === 'CAROUSEL_ALBUM' && galleryIconUrl) {
          appendMediaOverlay(link, galleryIconUrl);
        } else if (post.mediaType === 'VIDEO' && videoIconUrl) {
          appendMediaOverlay(link, videoIconUrl);
        }

        item.appendChild(link);
        fragment.appendChild(item);
      });

      grid.appendChild(fragment);
      grid.hidden = false;
    } catch (err) {
      if (error) {
        error.hidden = false;
      } else {
        root.hidden = true;
      }
    } finally {
      if (loading) loading.hidden = true;
    }
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initBeholdInstagram);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
